var cilWindowMinimize = ["512 512", "<rect width='416' height='32' x='48' y='448' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilWindowMinimize };

